import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { VirtualSearchPayload } from '@/types/virtual-search';
import { MblEntity } from '@/types/mbl/mbl.entity';
import { formatAggregationFilters } from '@/helpers/virtual-search';
import { MblVirtualFilterDefaultForm } from '@/constants/virtual-search/import/mbl';
import { useVirtualSearch } from '@/composables/virtual-search';
import MasterService from '@/services/imports/manifest/master.service';

export const useVirtualMblStore = defineStore('Virtual-MBL', () => {
  const options = computed<VirtualSearchPayload<MblEntity>>(() => ({
    chunkSize: 15,
    ...formatAggregationFilters(filterForm.value),
  }));
  const filterForm = ref(MblVirtualFilterDefaultForm());

  const { items, aggregations, isFetching, fetchedAllItems, search, total } = useVirtualSearch(
    MasterService.virtualSearch,
    options
  );

  const resetFilters = async () => {
    filterForm.value = MblVirtualFilterDefaultForm();
  };

  return {
    options,
    filterForm,
    items,
    aggregations,
    isFetching,
    total,
    fetchedAllItems,
    search,
    resetFilters,
  };
});
